var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiamond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.863 15.6779H10.1371L12.4249 8.17816H25.5751L27.863 15.6779Z",
    fill: "url(#paint0_linear_1_10898)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.55,
    d: "M10.1371 15.6778L19.0001 11.9326L27.863 15.6778H10.1371Z",
    fill: "url(#paint1_linear_1_10898)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0001 33.9534L10.1371 15.678H27.863L19.0001 33.9534Z",
    fill: "url(#paint2_linear_1_10898)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9828 21.5541H18.0513L18.9999 25.3932L23.2314 25.2243L18.9999 33.9537L12.9828 21.5541Z",
    fill: "url(#paint3_linear_1_10898)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8189 13.3682L27.8629 15.6772L25.5752 8.17746L31.676 5.86841L36.8189 13.3682Z",
    fill: "url(#paint4_linear_1_10898)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5752 8.17816L27.8629 15.6779L36.8189 13.3689L29.8904 11.9327L25.5752 8.17816Z",
    fill: "url(#paint5_linear_1_10898)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19 33.9527L27.8629 15.6774L36.8189 13.3683L19 33.9527Z",
    fill: "#3A9CB8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8189 13.3683L26.8864 22.1447L19 33.9527L36.8189 13.3683Z",
    fill: "url(#paint6_linear_1_10898)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1.18115 13.3682L10.1371 15.6772L12.4249 8.17746L6.32408 5.86841L1.18115 13.3682Z",
    fill: "url(#paint7_linear_1_10898)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4249 8.17816L7.94229 12.4865L1.18115 13.3689L10.1371 15.6779L12.4249 8.17816Z",
    fill: "url(#paint8_linear_1_10898)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19 33.9527L10.1371 15.6774L1.18115 13.3683L19 33.9527Z",
    fill: "#3A9CB8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1.18115 13.3683L10.165 20.9902L19 33.9527L1.18115 13.3683Z",
    fill: "url(#paint9_linear_1_10898)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.32397 5.86899L12.4248 8.17805H25.5751L31.676 5.86899L24.4312 3.55994H13.5687L6.32397 5.86899Z",
    fill: "url(#paint10_linear_1_10898)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.73,
    d: "M6.32397 5.86899L13.5687 3.55994H24.4312L17.856 4.66754L12.4248 8.17805L6.32397 5.86899Z",
    fill: "url(#paint11_linear_1_10898)"
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91383 15.2174C10.7601 15.5929 16.2658 26.8566 18.8605 33.6712C15.0753 27.3447 9.69062 16.1091 9.91383 15.2174Z",
    fill: "#E0F6FC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5752 8.17789C23.4176 8.17789 14.6383 8.38439 12.4249 8.67536L12.8992 8.32807L10.2951 15.7622C10.2884 15.7837 10.2776 15.8037 10.2632 15.821C10.2488 15.8384 10.2312 15.8527 10.2113 15.8632C10.1914 15.8735 10.1697 15.88 10.1474 15.8821C10.1251 15.884 10.1026 15.8815 10.0812 15.8747C10.0599 15.8679 10.04 15.857 10.0229 15.8425C10.0057 15.8279 9.9915 15.8101 9.98114 15.7901C9.97077 15.77 9.96443 15.7481 9.96245 15.7256C9.96049 15.7031 9.96292 15.6804 9.96965 15.6589L12.0901 7.62408C14.6941 7.98077 23.0456 8.14033 25.5752 8.17789Z",
    fill: "#E0F6FC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M6.32408 5.86841C12.8341 7.82078 13.0666 7.74569 12.8899 8.31825C12.8717 8.38127 12.8403 8.43959 12.7978 8.48935C12.7554 8.53909 12.7029 8.57908 12.6439 8.60665C12.5848 8.63421 12.5207 8.6487 12.4556 8.64914C12.3906 8.6496 12.3262 8.63599 12.2668 8.60924L6.32408 5.86841ZM1.18115 13.3683C4.08277 13.8001 7.61678 14.551 10.2673 15.1705H10.1371C16.0629 15.01 21.9929 15.1792 27.9002 15.6774C22.7572 16.2312 16.489 16.2405 14.6011 16.2594C8.97459 16.2031 11.0764 16.5879 5.60797 14.8702C4.10756 14.4134 2.63196 13.9127 1.18115 13.3683Z",
    fill: "#E0F6FC"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.87,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2149 20.7367C14.7405 21.1967 12.1272 19.1973 9.3744 16.2782C6.62159 13.359 4.77087 10.6087 5.24517 10.13C5.71948 9.65131 8.36999 11.6976 11.0949 14.6261C13.8198 17.5547 15.6891 20.2861 15.2149 20.7367Z",
    fill: "url(#paint12_radial_1_10898)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.87,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0984 15.4522C16.0984 15.9967 13.4014 16.4472 10.0906 16.4472C6.77978 16.4472 4.08276 15.9967 4.08276 15.4522C4.08276 14.9078 6.77048 14.4573 10.0906 14.4573C13.4107 14.4573 16.0984 14.8984 16.0984 15.4522Z",
    fill: "url(#paint13_radial_1_10898)"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_10898",
    x1: 10.3413,
    y1: 15.8093,
    x2: 25.4352,
    y2: 9.94423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53B3CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#7FC8DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4E1EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_10898",
    x1: 19.0001,
    y1: 15.5276,
    x2: 19.0001,
    y2: 11.6975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53B3CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#7FC8DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4E1EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_10898",
    x1: 19.0001,
    y1: 16.0622,
    x2: 18.8009,
    y2: 32.9958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53B3CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#7FC8DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4E1EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_10898",
    x1: 18.1076,
    y1: 33.4374,
    x2: 18.1076,
    y2: 20.7755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53B3CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#7FC8DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4E1EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_10898",
    x1: 25.5753,
    y1: 10.7776,
    x2: 36.8194,
    y2: 10.7776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B9FC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#3BAFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70CAE4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_10898",
    x1: 31.2019,
    y1: 15.3677,
    x2: 31.2019,
    y2: 7.70878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53B3CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#7FC8DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4E1EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_10898",
    x1: 27.909,
    y1: 33.098,
    x2: 27.909,
    y2: 12.0827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53B3CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#7FC8DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4E1EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1_10898",
    x1: 1.18067,
    y1: 10.7776,
    x2: 12.4247,
    y2: 10.7776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B9FC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#3BAFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70CAE4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1_10898",
    x1: 6.79812,
    y1: 15.3677,
    x2: 6.79812,
    y2: 7.70878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53B3CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#7FC8DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4E1EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1_10898",
    x1: 10.091,
    y1: 33.098,
    x2: 10.091,
    y2: 12.0827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53B3CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#7FC8DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4E1EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1_10898",
    x1: 18.9999,
    y1: 7.98131,
    x2: 18.9999,
    y2: 3.26931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53B3CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#7FC8DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4E1EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1_10898",
    x1: 16.5168,
    y1: 4.11317,
    x2: 10.6806,
    y2: 7.14793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53B3CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4E1EE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_1_10898",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.7487 14.917) rotate(46.5844) scale(7.28648 1.17484)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFF1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_1_10898",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.0412 15.2576) scale(6.00467 0.990267)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFF1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.99b545893608a780359ce116a8efae43.svg";
export { ForwardRef as ReactComponent };